// The register's wide presentation: the four sortable headers are the sort control, and
// aria-sort says which is sorted. The name links to the record.

import { Link } from 'react-router';

import { categories, commodities, flag, rating, status } from './cells.jsx';
import { SORTABLE_COLUMNS } from './counterpartyUrl.js';

export default function CounterpartyTable({ rows, products, query, onSort }) {
  const sortable = Object.fromEntries(SORTABLE_COLUMNS.map((c) => [c.key, c]));
  return (
    <div className="table-scroll">
      <table className="data-table">
        <thead>
          <tr>
            <SortHeader column={sortable.name} query={query} onSort={onSort} />
            <th className="plain">Categories</th>
            <th className="plain">Commodities</th>
            <th className="plain">Country</th>
            <SortHeader column={sortable.status} query={query} onSort={onSort} />
            <SortHeader column={sortable.rating} query={query} onSort={onSort} />
            <th className="plain">Added by</th>
            <SortHeader column={sortable.created} query={query} onSort={onSort} />
          </tr>
        </thead>
        <tbody>
          {rows.map((record) => (
            <tr key={record.counterparty_id}>
              <td><Link to={`/counterparties/${record.counterparty_id}`}>{record.name}</Link></td>
              <td>{categories(record)}</td>
              <td>{commodities(record, products)}</td>
              <td className="flag-cell">{flag(record)}</td>
              <td>{status(record)}</td>
              <td className="rating-cell">{rating(record)}</td>
              <td className="muted">{record.created_by ?? ''}</td>
              <td className="when">
                {record.created_at ? new Date(record.created_at).toLocaleDateString() : ''}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function SortHeader({ column, query, onSort }) {
  const sorted = query.sort === column.key;
  const ariaSort = !sorted ? 'none' : query.direction === 'asc' ? 'ascending' : 'descending';
  const marker = !sorted ? '' : query.direction === 'asc' ? ' ↑' : ' ↓';
  return (
    <th aria-sort={ariaSort}>
      <button type="button" onClick={() => onSort(column.key)}>{column.label}{marker}</button>
    </th>
  );
}
